/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import { useMutation } from "@tanstack/react-query";
import { client } from "services/api-client";

export const useGetSLADashboardOverview = () =>
  useMutation({
    mutationFn: (data: {
      datePreset: string;
      assignmentGroups: string[];
      fieldEngineer?: string[];
      customers?: string[];
      regions?: string[];
    }) =>
      client("dashboard/sla/overview", {
        data
      })
  });

export const useGetSLADashboardResponseOverview = () =>
  useMutation({
    mutationFn: (data: {
      datePreset: string;
      customers?: string[];
      activityTypes?: string[];
    }) =>
      client("dashboard/sla/response/overview", {
        data
      })
  });
export const useGetSLADashboardDetail = () =>
  useMutation({
    mutationFn: (data: {
      status: string | null;
      period: string;
      assignmentGroup: string | null;
      fieldEngineer: string | null;
      activityType: string | null;
      customerId: string | null;

      pageNumber?: number;
      pageRowCount?: number;
      regions?: string;
      searchCriteria?: string;
      eventCategory?: "SLA";
      eventType?: string | null;
      isBreached?: boolean | null;
      isAboutToBreach?: boolean | null;
      isSiteNotAccessible?: boolean | null;
    }) =>
      client("dashboard/sla/detail", {
        data
      })
  });
export const useExportSLADashboardDetail = () =>
  useMutation({
    mutationFn: (data: {
      status: string | null;
      period: string;
      assignmentGroup: string | null;
      activityType: string | null;
      customerId: string | null;

      searchCriteria?: string;
      eventCategory?: "SLA";
      eventType?: string | null;
      isBreached?: boolean | null;
      isAboutToBreach?: boolean | null;
      isSiteNotAccessible?: boolean | null;
    }) => client("dashboard/sla/detail/export", { data })
  });

export const useSaveDashboardFilter = () =>
  useMutation({
    mutationFn: (data: {
      DashboardName: string;
      Filters: {
        AssignmentGroups?: string[];
        DatePreset?: string;
        FieldEngineer?: string[];
        Customers?: string[];
        ActivityTypes?: string[];
        Accounts?: string[];
        Regions?: string[];
      };
    }) =>
      client("dashboard/save/filter", {
        method: "POST",
        data
      })
  });

/* ---------------- Dashboard Filter Get ---------------- */

export const useGetDashboardFilter = () =>
  useMutation({
    mutationFn: (dashboardName: string) =>
      client(`dashboard/get/filter?dashboardName=${dashboardName}`)
  });

export const useGetSlaKpi = () =>
  useMutation({
    mutationFn: (data: {
      datePreset: string;
      assignmentGroups: string[];
      fieldEngineer?: string[];
      customers?: string[];
      regions?: string[];
    }) =>
      client("dashboard/sla/kpi", {
        method: "POST",
        data
      }).then((res: { data: any }) => {
        return res.data;
      })
  });

export const useGetSlaSiteNotAccessibleKpi = () =>
  useMutation({
    mutationFn: (data: {
      isSiteNotAccessible: boolean;
      datePreset: string;
      assignmentGroups: string[];
      fieldEngineer?: string[];
      customers?: string[];
      regions?: string[];
    }) =>
      client("dashboard/sla/kpi/SiteNotAccessible", {
        method: "POST",
        data
      }).then((res: { data: any }) => {
        return res.data;
      })
  });
